var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highcharts',{ref:_vm.refId,staticClass:"hc",staticStyle:{"max-height":"500px"},attrs:{"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }